import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';

const styles = theme => ({
  root: {
    display: 'grid',
    alignContent: 'space-between',
  },
  code: {
    gridRow: 1,
    marginBottom: 20,
  },
  password: {
    gridRow: 2,
  },
});

const NewPassForm = ({ classes, code, setCode, newPass, setNewPass }) => {
  const [showPass, setShowPass] = useState(false);
  return (
    <div>
      <TextField
        InputProps={{ required: true }}
        className={classes.code}
        label="Verification code"
        helperText="Check your email for this code."
        value={code}
        onChange={e => setCode(e.target.value)}
        variant="outlined"
      />
      <TextField
        className={classes.password}
        type={showPass ? 'text' : 'password'}
        label="Your new password"
        value={newPass}
        onChange={e => setNewPass(e.target.value)}
        variant="outlined"
        InputProps={{
          required: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPass(!showPass)}>
                {showPass ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};

export default withStyles(styles)(NewPassForm);
